import React, { useEffect } from 'react';
import Svg, { Path } from 'react-native-svg';
import Animated, {
  useSharedValue,
  useAnimatedProps,
  withTiming,
  Easing,
} from 'react-native-reanimated';
import { useTheme } from '../../hooks/useTheme';

const AnimatedPath = Animated.createAnimatedComponent(Path);

// Approximate length of "M5 12 L10 17 L19 8" — used for the draw-in effect.
const PATH_LENGTH = 20;

interface IconStateProps {
  color?: string;
}

export const IconState: React.FC<IconStateProps> = ({ color }) => {
  const { colors } = useTheme();

  const dashOffset = useSharedValue(PATH_LENGTH);

  useEffect(() => {
    dashOffset.value = withTiming(0, {
      duration: 400,
      easing: Easing.out(Easing.cubic),
    });
  }, [dashOffset]);

  const animatedProps = useAnimatedProps(
    () => ({
      strokeDashoffset: dashOffset.value,
    }),
    [dashOffset],
  );

  return (
    <Svg width={20} height={20} viewBox="0 0 24 24" fill="none">
      <AnimatedPath
        d="M5 12 L10 17 L19 8"
        stroke={color ?? colors.text}
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray={PATH_LENGTH}
        animatedProps={animatedProps}
      />
    </Svg>
  );
};
